export const HEADWAY_ID_DEV = 'xGB38y';
export const HEADWAY_ID_BETA = 'xWaEYJ';
export const HEADWAY_ID_PROD = 'J02vVx';
